import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { collection, getDocs, limit, orderBy, query } from 'firebase/firestore';
import { db } from '../config/firebase-config';
import { JobModel } from '../types/jobs';

export type { JobModel as Job };


const DB_PATH = 'jobs'


interface JobState {
    jobs: JobModel[];
    selectedJob: JobModel | null;
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
}

const initialState: JobState = {
    jobs: [],
    selectedJob: null,
    status: 'idle',
    error: null,
};

export const fetchJobs = createAsyncThunk(DB_PATH + '/fetchJobs', async (companyId: string) => {
    const q = query(
        collection(db, 'companies', companyId, 'jobs'),
        orderBy('createdAt', 'desc'),
        limit(50)
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
    })) as JobModel[];
});

const JobSlice = createSlice({
    name: DB_PATH,
    initialState,
    reducers: {
        setJobs: (state, action: PayloadAction<JobModel[]>) => {
            state.jobs = action.payload;
        },
        setSelectedJob: (state, action: PayloadAction<JobModel | null>) => {
            state.selectedJob = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchJobs.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchJobs.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.jobs = action.payload;
            })
            .addCase(fetchJobs.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message || null;
            })
    },
});

export const { setJobs, setSelectedJob } = JobSlice.actions;
export default JobSlice.reducer;
